import React, { Fragment, useState } from "react";
import MainVideo from "./MainVideo";
import About from "./About";
import pic from "./Media/about us.png";
import picture from "./Media/goal.png";
import ProjectsImages from "./ProjectsImages";
import ProjectsSliders from "./ProjectsSlider";
import ContactUs from "./ContactUs";
import ContactedCompanies from "./ContactedCompanies";
import News from "./News";
import Navbar from "./Navbar";

export default function MainPage() {
  return (
    <Fragment>
      <Navbar />
      <div>
        <MainVideo />
        <About
          image={pic}
          title={"About Us"}
          txt={
            "To take its place as one of the leading companies in the field of manufacturing and developing software, applications, and websites. Focus company is interested in producing technical solutions for different business sectors that are easy to use and provide assistance in implementing unique and elegant designs for websites and providing customers with highly efficient hosting services. The importance of the Focus company lies in providing simple and effective systems to customers. To produce quality in a short time by studying the reality."
          }
          txtAr={
            "لتتبوأ مكانها كواحدة من الشركات الرائدة في مجال تصنيع وتطوير البرمجيات والتطبيقات والمواقع الإلكترونية. تهتم شركة فوكس بإنتاج حلول تقنية لقطاعات الأعمال المختلفة تكون سهلة الاستخدام وتوفر المساعدة في تنفيذ تصاميم فريدة وأنيقة للمواقع الإلكترونية وتقديم خدمات استضافة عالية  الكفاءة للعملاء.  يكمن أهمية شركة فوكس في توفير أنظمة بسيطة وفعالة للعملاء. لإنتاج جودة في وقت قصير من خلال دراسة الواقع."
          }
        />
        <About
          image={picture}
          title={"Our Plans"}
          txt={
            "In the age of speed, we aim to be pioneers and provide our customers the latest & most effective technical solutions to reach their goals and ours in return through keeping up with daily updates. Focus Company is working on designing and implementation of many projects for the service sector for several countries and private/governmental organizations, and it will be mentioned after the completion of the implementation."
          }
          txtAr={
            "في عصر السرعة، نهدف إلى أن نكون روادًا ونوفر لعملائنا أحدث وأكثر الحلول التقنية فعالية لتحقيق أهدافهم وأهدافنا بدورنا من خلال مواكبة التحديثات اليومية. تعمل شركة فوكس على تصميم وتنفيذ العديد من المشاريع لقطاع الخدمات في عدة بلدان ومؤسسات خاصة وحكومية، وسيتم ذكرها بعد الانتهاء من التنفيذ."
          }
        />
        <ProjectsImages />
        <ProjectsSliders />
        <News />
        <ContactedCompanies />
        <ContactUs />
      </div>
    </Fragment>
  );
}
